<template>
  <fragment
    ><v-form
      @submit.prevent="filterDiscountCoupon"
      ref="form"
      class="search-forms"
    >
      <v-row>
        <v-col cols="12" md="3" sm="4">
          <BaseTextField
            label="Código do Cupom"
            placeholder="Insira o código"
            v-model="filter.couponCode"
            type="text"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <BaseAutocomplete
            :items="allEvents"
            label="Evento"
            data-cy="produto"
            loader-height="5"
            :loading="$produtos_gerenciar.produtos_loading"
            v-model="filter.product"
            item-text="descricao"
            item-value="dsc_produto"
            no-data-text="Nenhum event encontrado"
            placeholder="Selecione o evento"
            clearable
            @click:clear="filter.product = ''"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <BaseSelect
            label="Consumidor"
            tabindex="3"
            :items="$loja_consumidor.consumidores"
            loader-height="5"
            :loading="$loja_consumidor.cadastro.loading_consumidores"
            v-model="filter.consumer"
            item-text="nome"
            item-value="idconsumidor"
            placeholder="Selecione o consumidor"
            clearable
            @click:clear="filter.consumer = ''"
          />
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu"
            v-model="menu"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Inicial"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.initDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.initDate"
              :active-picker.sync="activePicker"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" md="3" sm="4">
          <v-menu
            offset-y
            ref="menu2"
            v-model="menu2"
            min-width="auto"
            transition="scale-transition"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <BaseTextField
                clearable
                hide-details
                label="Data Final"
                placeholder="dd/mm/aaaa"
                v-mask="'##/##/####'"
                v-model="filter.endDateView"
                v-on="on"
                v-bind="attrs"
                :append-icon="$config.icons.calendar"
              />
            </template>

            <v-date-picker
              locale="pt"
              v-model="filter.endDate"
              :active-picker.sync="activePicker2"
              :header-color="$config.dados.corinputs"
              :color="$config.dados.corinputs"
              @change="save2"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col class="d-flex justify-end">
          <BaseButton
            tabindex="13"
            variant="filter"
            class="button rounded-xxl"
            type="submit"
            :loading="discountCouponLoading"
          >
            Filtrar
          </BaseButton>
        </v-col>
      </v-row>
    </v-form>

    <v-data-table
      class="rounded-lg"
      hide-details
      no-data-text="Não há registros."
      loading-text="Buscando informações...."
      :loading="discountCouponLoading"
      :headers="headersTable"
      :items="allDiscountCoupon.info"
      :items-per-page="10"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Cupons por página:',
      }"
    >
      <template v-slot:item.total_desconto_cupom="{ item }">
        {{ item.total_desconto_cupom | moeda }}
      </template>
      <template v-slot:item.ult_dthr_cupom_aplicado="{ item }">
        {{ item.ult_dthr_cupom_aplicado | dthr_pt_br }}
      </template>
      <template v-slot:item.total_valor_liquido="{ item }">
        {{ item.total_valor_liquido | moeda }}
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
export default {
  name: "DiscountCoupon",
  metaInfo: {
    title: "Relatório Sintético de Cupons de Desconto | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Relatório Sintético de Cupons de Desconto | ElevenTickets",
      },
    ],
  },
  props: {},
  components: { BaseSelect, BaseTextField, BaseAutocomplete, BaseButton },
  data() {
    return {
      filter: {
        couponCode: "",
        product: "",
        consumer: "",
        initDate: "",
        initDateView: "",
        endDate: "",
        endDateView: "",
      },
      dayjs: dayjs,
      activePicker: null,
      activePicker2: null,
      activePickerOrders: null,
      activePickerRelease: null,
      date: null,
      menu: false,
      menu2: false,
      disableConsumidor: true,
      disableProdutos: true,
      tipo_pessoa: [],
      headersTable: [
        {
          text: "Código",
          align: "center",
          sortable: false,
          value: "codigo",
          width: 200,
        },
        {
          text: "Data/Hora Uso",
          align: "center",
          value: "ult_dthr_cupom_aplicado",
          width: 200,
        },
        {
          text: "Quantidade Restante",
          align: "center",
          value: "qtd_restante",
          width: 200,
        },
        {
          text: "Quantidade Utilizada",
          align: "center",
          value: "qtd_utilizado",
          width: 200,
        },
        {
          text: "Ingressos Adquiridos",
          align: "center",
          value: "qtd_itens_vendidos",
          width: 180,
        },
        {
          text: "Valor Desconto",
          align: "center",
          value: "total_desconto_cupom",
          width: 200,
        },
        {
          text: "Valor Líquido Gerado",
          align: "center",
          value: "total_valor_liquido",
          width: 180,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "intervalDates",
      "allDiscountCoupon",
      "discountCouponLoading",
      "allEvents",
    ]),
  },
  methods: {
    ...mapActions(["fetchDiscountCouponReport", "fetchEvents"]),
    ...mapMutations(["setDiscountCouponLoading", "setReportsFilter"]),
    filterDiscountCoupon() {
      this.setDiscountCouponLoading(true);
      let filter = {};

      if (this.filter.initDateView) {
        Object.assign(filter, {
          dthr_cupom_aplicado_ini: `${this.filter.initDate} 00:00`,
        });
      }

      if (this.filter.endDateView) {
        Object.assign(filter, {
          dthr_cupom_aplicado_fim: `${this.filter.endDate} 23:59`,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        codigo: this.filter.couponCode,
        dsc_produto: this.filter.product,
        idconsumidor: this.filter.consumer,
      });

      this.setReportsFilter(filter);
      this.fetchDiscountCouponReport(filter);
    },
    searchTipoPessoa(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.text.toString().toLocaleLowerCase().normalize("NFD")
      );
      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    save(date) {
      this.$refs.menu.save(date);
      this.filter.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.filter.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
  },
  watch: {
    "$store.getters.storeSequencial"() {
      if (this.storeSequencial) {
        this.$loja_consumidor.getConsumidor(this.storeSequencial);
        this.$produtos_gerenciar.getProdutosCategoria(this.storeSequencial);
        this.filterDiscountCoupon();
      }
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
  },
  beforeMount() {
    if (this.storeSequencial) {
      this.$loja_consumidor.getConsumidor(this.storeSequencial);
      this.fetchEvents({ producerId: this.storeSequencial, filtro: [] });
      this.fetchDiscountCouponReport({ producerId: this.storeSequencial });
    }
  },
  destroyed() {
    this.filter = {
      couponCode: "",
      product: "",
      consumer: "",
      initDate: "",
      initDateView: "",
      endDate: "",
      endDateView: "",
    };
  },
};
</script>
<style scoped></style>
